// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as DeleteGstinApiModel from "../api-model/DeleteGstinApiModel.bs.js";

function decodeApiModel(json) {
  return {
          customer_id: json.customer_id,
          deleted_gstins: json.deleted_gstins
        };
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(DeleteGstinApiModel.t_decode(json), "DeleteGstinEntityMapper.res"));
}

export {
  decodeApiModel ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
